export default "__VITE_ASSET__Daxrr2yU__"